import {
    clearActiveUser,
    setActiveUserData,
    setActiveUserEmail,
    setActiveUserIsValid,
    setActiveUserToken
} from "./activeUser/action";
import { removeActiveEntry, setActiveEntry, setActiveLanguage, setBrainGameData } from "./brainGame/actions";
import { clearProjectData, setProjectData, setProjectId, setProjectPageCommand, setProjectPageCommandId, setProjectPageCommandSubSelect } from "./project/actions";
import { systemSetAppConfig, systemSetLanguages, systemToggleDarkTheme } from "./system/action";

const actions = {
    activeUser: {
        setToken: setActiveUserToken,
        setData: setActiveUserData,
        setEmail: setActiveUserEmail,
        setValidity: setActiveUserIsValid,
        clearData: clearActiveUser,
    },
    project: {
        setId: setProjectId,
        setData: setProjectData,
        clearData: clearProjectData,
        setPageCommand: setProjectPageCommand,
        setPageCommandId: setProjectPageCommandId,
        setPageCommandSubSelect: setProjectPageCommandSubSelect,
    },
    brainGame: {
        setData: setBrainGameData,
        setActiveEntry: setActiveEntry,
        removeActiveEntry: removeActiveEntry,
        setActiveLanguage: setActiveLanguage,
    },
    system: {
        toggleDarkTheme: systemToggleDarkTheme,
        setLanguages: systemSetLanguages,
        setAppConfig: systemSetAppConfig,
    },
}

export { actions };
